import { render, staticRenderFns } from "./headMenu.vue?vue&type=template&id=d1942f48&scoped=true"
import script from "./headMenu.vue?vue&type=script&lang=js"
export * from "./headMenu.vue?vue&type=script&lang=js"
import style0 from "./headMenu.vue?vue&type=style&index=0&id=d1942f48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1942f48",
  null
  
)

export default component.exports